import { defineMessages } from 'react-intl';

export const reasoningModeMenuMessages: {
	autoLabel: { id: string; defaultMessage: string; description: string };
	fastLabel: { id: string; defaultMessage: string; description: string };
	fastTitle: { id: string; defaultMessage: string; description: string };
	fastDescription: { id: string; defaultMessage: string; description: string };
	thinkingLabel: { id: string; defaultMessage: string; description: string };
	researchingLabel: { id: string; defaultMessage: string; description: string };
	menuTriggerTooltip: { id: string; defaultMessage: string; description: string };
	autoTitle: { id: string; defaultMessage: string; description: string };
	autoDescription: { id: string; defaultMessage: string; description: string };
	thinkDeeperTitle: { id: string; defaultMessage: string; description: string };
	thinkDeeperDescription: { id: string; defaultMessage: string; description: string };
	thinkDeeperMarathonTitle: { id: string; defaultMessage: string; description: string };
	thinkDeeperMarathonDescription: { id: string; defaultMessage: string; description: string };
	thinkDeeperOrchestratorTitle: { id: string; defaultMessage: string; description: string };
	thinkDeeperOrchestratorDescription: { id: string; defaultMessage: string; description: string };
	deepResearchTitle: { id: string; defaultMessage: string; description: string };
	deepResearchDescription: { id: string; defaultMessage: string; description: string };
	taskLabel: { id: string; defaultMessage: string; description: string };
	taskTitle: { id: string; defaultMessage: string; description: string };
	taskDescription: { id: string; defaultMessage: string; description: string };
	taskModeDescription: { id: string; defaultMessage: string; description: string };
	taskModeDescriptionRefresh: { id: string; defaultMessage: string; description: string };
	deepResearchAddMenuDisabledTooltip: { id: string; defaultMessage: string; description: string };
	agentDisabledTooltip: { id: string; defaultMessage: string; description: string };
	lozengeAlpha: { id: string; defaultMessage: string; description: string };
	lozengeNew: { id: string; defaultMessage: string; description: string };
} = defineMessages({
	autoLabel: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.auto.label',
		defaultMessage: 'Auto',
		description: 'Label shown on the reasoning mode pill button when Auto mode is selected',
	},
	fastLabel: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.fast.label',
		defaultMessage: 'Quick',
		description: 'Label shown on the reasoning mode pill button when Fast mode is selected',
	},
	fastTitle: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.fast.title',
		defaultMessage: 'Quick answers',
		description: 'Title of the Fast reasoning mode option in the popover menu',
	},
	fastDescription: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.fast.description',
		defaultMessage: 'Faster replies with lighter reasoning',
		description: 'Description of the Fast reasoning mode option in the popover menu',
	},
	thinkingLabel: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.thinking.label',
		defaultMessage: 'Thinking',
		description: 'Label shown on the reasoning mode pill button when Think Deeper mode is selected',
	},
	researchingLabel: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.researching.label',
		defaultMessage: 'Researching',
		description:
			'Label shown on the reasoning mode pill button when Deep Research mode is selected',
	},
	menuTriggerTooltip: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.trigger.tooltip',
		defaultMessage: 'Change reasoning mode',
		description: 'Tooltip for the reasoning mode menu trigger button',
	},
	autoTitle: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.auto.title',
		defaultMessage: 'Let Rovo decide',
		description: 'Title for the Auto reasoning mode in the reasoning mode menu popover',
	},
	autoDescription: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.auto.description',
		defaultMessage: 'Rovo picks reasoning for the job',
		description: 'Description for the Auto reasoning mode in the reasoning mode menu popover',
	},
	thinkDeeperTitle: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.think-deeper.title',
		defaultMessage: 'Think deeper',
		description: 'Title for the Think Deeper reasoning mode in the reasoning mode menu popover',
	},
	thinkDeeperDescription: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.think-deeper.description',
		defaultMessage: 'Longer thinking for robust responses',
		description:
			'Description for the Think Deeper reasoning mode in the reasoning mode menu popover',
	},
	thinkDeeperMarathonTitle: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.think-deeper-marathon.title',
		defaultMessage: 'Think deeper (Marathon)',
		description:
			'Title for the Think Deeper Marathon reasoning mode in the reasoning mode menu popover',
	},
	thinkDeeperMarathonDescription: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.think-deeper-marathon.description',
		defaultMessage: "Try Rovo's marathon agent",
		description:
			'Description for the Think Deeper Marathon reasoning mode in the reasoning mode menu popover',
	},
	thinkDeeperOrchestratorTitle: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.think-deeper-orchestrator.title',
		defaultMessage: 'Think deeper (Orchestrator)',
		description:
			'Title for the Think Deeper Orchestrator reasoning mode in the reasoning mode menu popover',
	},
	thinkDeeperOrchestratorDescription: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.think-deeper-orchestrator.description',
		defaultMessage: "Try Rovo's new long orchestrator",
		description:
			'Description for the Think Deeper Orchestrator reasoning mode in the reasoning mode menu popover',
	},
	deepResearchTitle: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.deep-research.title',
		defaultMessage: 'Deep Research',
		description: 'Title for the Deep Research reasoning mode in the reasoning mode menu popover',
	},
	deepResearchDescription: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.deep-research.description',
		defaultMessage: 'Synthesize insights and create reports',
		description:
			'Description for the Deep Research reasoning mode in the reasoning mode menu popover',
	},
	taskLabel: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.task.label',
		defaultMessage: 'Max',
		description: 'Label shown on the reasoning mode pill button when Task mode is selected',
	},
	taskTitle: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.task.title',
		defaultMessage: 'Max',
		description: 'Title for the Task reasoning mode in the reasoning mode menu popover',
	},
	taskDescription: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.task.description',
		defaultMessage: 'The smartest way to get work done',
		description: 'Description for the Task reasoning mode in the reasoning mode menu popover',
	},
	taskModeDescription: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.task.mode.description',
		defaultMessage: 'The do-it-all mode for complex, evolving work',
		description: 'Description for the Task reasoning mode in the reasoning mode menu popover',
	},
	taskModeDescriptionRefresh: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.task.mode.description.refresh',
		defaultMessage: 'Tackles complex work across your tools',
		description:
			'Updated description for the Task reasoning mode in the reasoning mode menu popover behind design refresh',
	},
	deepResearchAddMenuDisabledTooltip: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.deep-research-add-menu-disabled-tooltip',
		defaultMessage: 'Rovo auto-selects the appropriate reasoning mode for deep research',
		description:
			'Tooltip shown on the reasoning mode selector when it is disabled because Deep Research is active from the add menu',
	},
	agentDisabledTooltip: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.agent-disabled-tooltip',
		defaultMessage: 'Reasoning mode is only available when chatting with Rovo.',
		description:
			'Tooltip shown on the reasoning mode selector when it is disabled because the user is chatting with an agent. It explains that reasoning mode is available in regular Rovo Chat.',
	},
	lozengeAlpha: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.lozenge.alpha',
		defaultMessage: 'Alpha',
		description: 'Alpha lozenge label shown on experimental reasoning mode menu items',
	},
	lozengeNew: {
		id: 'ai-mate.chat-input.reasoning-mode-menu.lozenge.new',
		defaultMessage: 'New',
		description: 'New lozenge label shown on newly launched reasoning mode menu items',
	},
});
